
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    mixins: [ScreenSize],
    data() {
      return {
        searchText: '',
        lettersFilter: [],
        wikis: [],
        filteredWikis: [],
        disabled: false,
      };
    },
    async fetch() {
      const wikis = await this.$cachedStrapi.find('wikis');
      this.wikis = wikis;
      this.wikis.filter((wiki) => {
        const firstLetter = wiki.title.charAt(0);
        this.lettersFilter.push(firstLetter);
      });
      this.lettersFilter = this.removeDuplicated(this.lettersFilter).sort();
    },
    methods: {
      removeDuplicated(data) {
        return data.filter((value, index) => data.indexOf(value) === index);
      },
      filterByLetter(letter) {
        this.filteredWikis = [];
        if (letter) {
          this.wikis.filter((wiki) => {
            const firstLetter = wiki.title.charAt(0);
            if (firstLetter === letter) {
              this.filteredWikis.push(wiki.slug);
            }
          });
        }
        this.searchText = '';
        this.$emit('search-by-letter', this.filteredWikis);
      },
      resetWikiSearch() {
        this.searchText = '';
        this.$emit('reset-wiki-search');
      },
      applyFilter() {
        this.disabled = true;
        setTimeout(() => (this.disabled = false), 3000);
        this.$emit('search-wiki', this.searchText);
      },
    },
  };
